/*
 * @Author: czj
 * @Date: 2025-04-17 10:52:16
 * @Description: 
 * @FilePath: \sxtracellular-single-cell\src\main.js
 */

import { createApp } from 'vue'
import App from './App.vue';
import router from '@/router/index';
import { createPinia } from 'pinia';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import i18n from './locales/index';

// console.log = () => undefined;// 屏蔽控制台输出
const app = createApp(App);

const pinia = createPinia()

for (const [key, component] of Object.entries(ElementPlusIconsVue)) { // 注册element-plus的icon
  app.component(key, component)
};

app.use(router);
app.use(ElementPlus);
app.use(i18n)  // ⚡️重点：要挂载 i18n
app.use(pinia)  // ⚡️重点：要挂载 pinia
app.mount('#app');
